// extracted by mini-css-extract-plugin
module.exports = {"container":"iBK6eu","imageContainer":"XZ7dGd","text":"j4__09"};